import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { LoadingCards } from '../components/LoadingCards';
import Confetti from '../assets/imgs/confetti.png';
import SadFace from '../assets/imgs/sad-face.png';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, firestore } from '../firebase';
import { changePaymentStatus, createSupportTicket, getPendingBookings } from '../utils/FirebaseFunctions';

const PaymentStatus = () => {
  const { sessionId } = useParams();
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [user, userLoading] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {

    if(!userLoading) {
      const getPaymentDetails = async () => {
        try {
          const response = await axios.get(`https://medicomp-payment.onrender.com/getPaymentDetails?sessionId=${sessionId}`);
          setPaymentDetails(response.data);
          console.log(response.data.paymentStatus)
          getPendingBookings(user.uid).then((bookings) => {
            if(bookings.length === 1) {
              changePaymentStatus(user.uid, bookings[0].id, { status: response.data.paymentStatus, checkoutID: sessionId }).then(r => {
                // createSupportTicket({
                //   bookingId: bookings[0].id,
                //   issue: 'General',
                //   surgeryName: bookings[0].surgeryName,
                //   status: 'open',
                //   uid: user?.uid
                // })
              })
            }
          })
        } catch (error) {
          setError(error.message || 'An error occurred while fetching payment details');
        } finally {
          setTimeout(() => {
            setLoading(false);
          }, 2500);
        }
      };
  
      getPaymentDetails();
    }

  }, [userLoading]);

  return (
    <div className="p-5 w-screen h-full flex flex-col items-center justify-center">
      {loading && <div className="mb-auto w-full"><LoadingCards /></div>}
      {error && <div className="text-red-500">{error}</div>}
      {(!loading && !error ) && (
        <div className="flex flex-col items-center bg-white mb-[30px] w-full p-5 rounded-lg shaow-lg">
          {paymentDetails?.paymentStatus === 'paid' && (
            <>
              <img src={Confetti} className="w-[50%] mt-[30px] h-auto" alt="" />
              <h1 className="text-xl mt-[60px] font-medium text-black font-nunito text-center">Payment Successful !!</h1>
              <p className="text-sm px-5 font-nunito text-center mt-[20px]">
                The booking has been made. Our team will contact you shortly. And let you know all the details. You can always reach out to us at the support section or email us directly at
                <strong className="text-black"> admin@medisupport.com</strong>
              </p>
              <button onClick={() => {
                setLoading(true);
                setTimeout(() => {
                  navigate('/');
                }, 3000);
              }} className="bg-[#0080f3] text-white font-nunito text-sm px-5 py-3 w-full rounded-lg mt-[30px]">
                Home
              </button>
            </>
          )}

          {/* payment failed */}
          {paymentDetails.paymentStatus !== 'paid' && (
            <>
              <img src={SadFace} className="w-[50%] mt-[30px] h-auto" alt="" />
              <h1 className="text-xl mt-[60px] font-medium text-black font-nunito text-center">Payment Failed !!</h1>
              <p className="text-sm px-5 font-nunito text-center mt-[20px]">
                The booking didn't go through. Please visit the product retry the payment. If any amount has been debited from your account, it will be refunded back to your account within 5 to 7 working days.
                <br /> <br /> You can always reach out to us at the support section or email us directly at
                <strong className="text-black"> admin@medisupport.com</strong>
              </p>
              <button onClick={() => {
                window.location = 'https://book.stripe.com/test_fZeaEObAt88Bere8ww';
              }} className="bg-[#0080f3] text-white font-nunito text-sm px-5 py-3 w-full rounded-lg mt-[30px]">
                Retry Payment
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default PaymentStatus;
